import React from 'react';
import PropTypes from 'prop-types';
import clsx from "clsx";
import styles from './ResumeBox.module.scss';

export const ResumeBox = ({icon: Icon, title, children}) => {
  return (
    <div className={styles.boxStyle}>
      <div className="pr-3">
        <span className={clsx(styles.sectionIcon)}>
          <Icon/>
        </span>
      </div>
      <div className="flex flex-col flex-1">
        <h5 className="title text-nowrap mb-0.5">{title}</h5>
        <div className={styles.body}>
          {children}
        </div>
      </div>
    </div>
  );
};

ResumeBox.propTypes = {
  title: PropTypes.string,
  imageSrc: PropTypes.string
}

ResumeBox.defaultProps = {}

export default ResumeBox;